import { Button, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";

export const ButtonBlockDanger = ({ text, onClick }) => {
  return (
    <Button type="submit" block variant="danger" onClick={onClick}>
      {text}
    </Button>
  );
};
export const ButtonDontSubmit = ({ text, onClick, style }) => {
  return (
    <Button variant="danger" onClick={onClick} className={style}>
      {text}
    </Button>
  );
};
export const ButtonDanger = ({
  text,
  onClick,
  style,
  disabled,
  fullWidth,
  teamFullWidth,
  type,
  btnShowTeam,
}) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <Button
      variant="contained"
      color="primary"
      style={{
        width: teamFullWidth
          ? "160px"
          : isLargeScreen
          ? fullWidth && "300px"
          : "150px",
        backgroundColor: disabled ? "#ccc" : "#E00000",
        color: "white",
        backgroundImage: "none",
        boxShadow: "none",
        textTransform: "capitalize",
        margin: btnShowTeam && "5px 8px",
      }}
      {...(type === "submit" && { type: "submit" })}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};
export const ButtonDark = ({ text, onClick, style, disabled }) => {
  return (
    <Button
      type="submit"
      disabled={disabled}
      variant="dark"
      onClick={onClick}
      className={style}
    >
      {text}
    </Button>
  );
};
